import { useApiData } from './useApiData'
import { useServiceState } from './useServiceState'

export type AccountingStatus = {
  loading: boolean
  isOffline: boolean
  disclaimers?: {
    visibility?: {
      showInCompanyDetail?: boolean
      showInCheckout?: boolean
      showInCart?: boolean
      showInBalance?: boolean
      showInAccount?: boolean
    }
    companyDetail?: {
      showToSelfRegisteredUsers?: boolean
      showToSubscribers?: boolean
      showToAnonymousUsers?: boolean
    }
  }
}

export function useAccountingStatus(): AccountingStatus {
  const { discovery: isAccountingOffline, discoveryLoading: isAccountingStatusLoading } = useServiceState('SAP')

  const { data: disclaimers, loading: disclaimersLoading } = useApiData(
    {
      url: '/api/content/accountingDisclaimers',
      method: 'get'
    },
    { umbracoCall: true, skip: isAccountingOffline?.isOnline !== false }
  )

  return {
    loading: isAccountingStatusLoading || disclaimersLoading,
    isOffline: isAccountingOffline?.isOnline === undefined ? false : !isAccountingOffline?.isOnline,
    disclaimers
  }
}
